import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";

const LINKS = [
  { label: "Home", to: "/" },
  { label: "Technology", to: "/technology" },
  { label: "Carbon Free Generator", to: "/carbon-free-generator" },
  { label: "Contact", to: "/contact" },
];

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found — BNM Sustainable Energy Limited" description="The page you requested could not be found." />
      <section data-testid="not-found-page" className="relative min-h-screen overflow-hidden bg-obsidian grid-lines-dark noise-overlay flex items-center">
        <div className="absolute inset-0 hero-glow pointer-events-none" aria-hidden="true" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 w-full">
          <p className="font-mono text-xs uppercase tracking-[0.24em] text-volt">Error 404</p>
          <h1 className="mt-5 font-display text-6xl sm:text-8xl font-extrabold tracking-tight text-white">
            Signal lost.
          </h1>
          <p className="mt-5 max-w-lg text-base sm:text-lg leading-relaxed text-slate-400">
            The page you requested does not exist or has moved. Reconnect through one of the routes below.
          </p>
          <div className="mt-9 flex flex-wrap gap-3">
            {LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`not-found-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="inline-flex items-center gap-2 rounded-md border border-white/20 px-5 py-3 text-sm font-semibold text-white transition-colors hover:border-volt/60 hover:text-volt"
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/"
              data-testid="not-found-home-cta"
              className="inline-flex items-center gap-2 rounded-md bg-volt px-5 py-3 text-sm font-semibold text-obsidian transition-[transform,background-color] duration-200 hover:-translate-y-0.5 hover:bg-volt-soft hover:text-obsidian"
            >
              <ArrowLeft className="h-4 w-4" aria-hidden="true" />
              Back to Home
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
